<p-accordionTab>


    <p-header>
      <div class="ui-helper-clearfix">
        <div class="left">
          <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">POLYGON GEO-FENCE CONFIGURATION (AT+GTPEO)</span>
        </div>
      </div>
    </p-header>
  
    <div class="ui-g">
      <div class="ui-g">
        <p-accordionTab [selected]="true">
          <p-header>
            <div class="ui-helper-clearfix">
              <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Polygon Geo-Fence Settings</span>
              </div>
            </div>
          </p-header>

          <div class="row align-items-center">
  
            <div class="col row dvcFields">
              <div class="col lblStyle">
                <form-input fieldName="GEO ID">
                </form-input>
              </div>
            <div class="col">
                <p-dropdown [options]="idOptions"
                [style]="{'width':'100%','min-width':'100px'}" (onChange) = "onPeoIdChange($event)"></p-dropdown>
            </div>
            </div>
         </div>
         <div class="row align-items-center">
            <div class="col row dvcFields">
                <div class="col lblStyle">
                  <form-input fieldName="Mode">
                  </form-input>
                </div>
                <div class="col">
                  <p-dropdown [options]="modeOptions"
                    [(ngModel)]="peoParameters[selectedIndex].mode" [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
                </div>
              </div>
        </div>   
  

  
        
        </p-accordionTab>
      </div>
  
      <div class="ui-g">
        <p-accordionTab [selected]="true">
          <p-header>
            <div class="ui-helper-clearfix">
              <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Output
                  Settings</span>
              </div>
            </div>
          </p-header>
          
          <div class="row align-items-center">
            <div class="col row dvcFields">
                    <div class="col lblStyle">
                        <form-input fieldName="Start Point">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                            <p-spinner size="5" step="1" [(ngModel)]="peoParameters[selectedIndex].startPoint" [min]="1" [max]="8"></p-spinner>
                            <span class="ui-inputgroup-addon">1~8</span>
                        </div>
                    </div>
            </div>
            <div class="col row dvcFields">
                <div class="col lblStyle">
                    <form-input fieldName="End Point">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="peoParameters[selectedIndex].endPoint" [min]="3" [max]="10"></p-spinner>
                        <span class="ui-inputgroup-addon">3~10</span>
                    </div>
                </div>
            </div>              
        </div>
        <div class="row align-items-center">
            <div class="col row dvcFields">
                <form-input fieldName="End Point 1"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude1"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude1"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>   
            </div>
            <div class="col row dvcFields">
                <form-input fieldName="End Point 2"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude2"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude2"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div> 
            </div>                
        </div>
        <div class="row align-items-center">
            <div class="col row dvcFields">
                <form-input fieldName="End Point 3"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude3"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude3"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>   
            </div>
            <div class="col row dvcFields">
                <form-input fieldName="End Point 4"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude4"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude4"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div> 
            </div>                
        </div>
        <div class="row align-items-center">
            <div class="col row dvcFields">
                <form-input fieldName="End Point 5"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude5"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude5"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>   
            </div>
            <div class="col row dvcFields">
                <form-input fieldName="End Point 6"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude6"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude6"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div> 
            </div>                
        </div>
        <div class="row align-items-center">
            <div class="col row dvcFields">
                <form-input fieldName="End Point 7"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude7"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude7"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>   
            </div>
            <div class="col row dvcFields">
                <form-input fieldName="End Point 8"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude8"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude8"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div> 
            </div>                
        </div>
        <div class="row align-items-center">
            <div class="col row dvcFields">
                <form-input fieldName="End Point 9"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude9"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude9"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>   
            </div>
            <div class="col row dvcFields">
                <form-input fieldName="End Point 10"></form-input>
                
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Longitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].longitude10"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div>
                <div class="row align-items-center">
                    <div class="col lblStyle">
                        <form-input fieldName="Latitude">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                          <input type="number" pInputText [(ngModel)]="peoParameters[selectedIndex].latitude10"
                            [style]="{'width':'100%','min-width':'100px'}" />
                        </div>
                      </div>
                </div> 
            </div>                
        </div>
        <div class="row align-items-center">
            <div class="col row dvcFields">
                <div class="col lblStyle">
                    <form-input fieldName="Check Interval">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="peoParameters[selectedIndex].checkInterval" [min]="0" [max]="86400"></p-spinner>
                        <span class="ui-inputgroup-addon">0~86400</span>
                        <span class="ui-inputgroup-addon">sec</span>
                    </div>
                </div>
            </div>
        </div>
        </p-accordionTab>
      </div>
    </div>
  
  </p-accordionTab>